<template>
  <div class="stat-prices stat-block pt-4 pb-3">
    <stat-loader :display="loader"></stat-loader>

    <div class="container">

      <div class="row">
        <div class="col-7">
          <h2 class="mb-4 pb-1 pt-1">Spotpriser och marknadspriser</h2>
        </div>
        <div class="col-5 text-right scales-nav mt-3">
          <span v-for="{name, handle} in scales" :class="{active: scale === handle}" class="scale-item ml-3">
            <span @click="scale = handle">{{ name }}</span>
          </span>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-8 categories-nav">
          <stat-price-category
            :key="category.id"
            :name="category.name"
            :id="category.id"
            v-model="category_id"
            v-for="category in areaCategories"/>

          <div class="clearfix"></div>
        </div>
        <div class="col-4 contract-types">
          <div class="form-group">
            <select class="form-control" v-model="contract_type">
              <option v-for="type in contractTypes" :value="type.handle">
                {{ type.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div id="chart" v-if="loaded">
        <apexchart type=line height=350 :options="chartOptions" :series="series"/>
      </div>

    </div>
  </div>
</template>

<script>

  import {mapState} from "vuex"
  import StatPriceCategory from "./Period/Category"
  import {areaCategories, contractTypes, statisticsScales} from "./../../../../../app/services/Data/GeneralData"
  import StatLoader from "../../Partials/Loader"
  import DateMixin from "../../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "StatPricesPeriod",
    components: {StatLoader, StatPriceCategory},
    mixins: [
      DateMixin
    ],
    computed: {
      ...mapState({
        loaded: state => state.statistics.prices.period.loaded,
        statistics: state => state.statistics.prices.period.data,
      }),
      areaCategories() {
        let output = areaCategories()

        output.unshift({
          id: null,
          name: 'All country'
        })

        return output
      },
      contractTypes() {
        let output = contractTypes()

        output.unshift({
          handle: null,
          name: 'All contract types'
        })

        return output
      },
      scales() {
        return statisticsScales()
      },
      series() {
        return [
          {
            name: 'Spotpriser',
            data: this.statistics.spot.map(attributes => attributes.price)
          },
          {
            name: 'Marknadspriser',
            data: this.statistics.market.map(attributes => attributes.price)
          },
        ]
      },
      labels() {
        let output = []

        for (let label of this.statistics.labels) {

          let text

          switch (this.scale) {
            case 'month':
              text = this.monthTextYear(label)
              break
            case 'week':
            case 'day':
            default:
              text = this.dayMonth(label)
              break
          }

          output.push(text)
        }

        return output
      },
      chartOptions() {
        return {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          xaxis: {
            categories: this.labels,
          }
        }
      }
    },
    watch: {
      async category_id(value) {
        await this.fetch()
      },
      async contract_type(value) {
        await this.fetch()
      },
      async scale(value) {
        await this.fetch()
      }
    },
    async mounted() {
      await this.fetch()
    },
    methods: {
      async fetch() {
        this.loader = true

        const input = {
          scale: this.scale,
          category_id: this.category_id,
          contract_type: this.contract_type,
        }

        await this.$store.dispatch('statistics/period', input)

        this.loader = false
      }
    },
    data() {
      return {
        scale: 'day',
        category_id: null,
        contract_type: null,
        loader: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Market/Prices/Period.vue